import React, { useState } from 'react';
import { VisibilityOff, RemoveRedEye } from '@material-ui/icons';

const InputField = (props) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div style={{ width: '100%' }}>
            <div className="inputField-container" style={{ position: 'relative' }}>
                <input
                    onChange={(text) => props.handleChange(text.target.value)}
                    placeholder={props.placeholder}
                    type={props.isPassword ? (showPassword ? 'text' : 'password') : 'text'}
                    onKeyPress={props.onKeyPress}
                />
                {props.isPassword ? (
                    showPassword ? (
                        <VisibilityOff
                            style={{ position: 'absolute', right: 10, top: '50%', cursor: 'pointer', transform: 'translateY(-50%)' }}
                            onClick={togglePasswordVisibility}
                        />
                    ) : (
                        <RemoveRedEye
                            style={{ position: 'absolute', right: 10, top: '50%', cursor: 'pointer', transform: 'translateY(-50%)' }}
                            onClick={togglePasswordVisibility}
                        />
                    )
                ) : null}
            </div>
            <span className="mb-2 login-error-text">{props.error}</span>
        </div>
    );
};

export default InputField;
